import { DateInput, DateInputProps } from "@react-admin/ra-form-layout";

const CustomDateInput = (props: DateInputProps) => {
  return <DateInput mask="dd/MM/yyyy" {...props} />;
};

export default CustomDateInput;
